import React from "react";
import AppointmentCard from "./account/AppointmentCard";
import InstalledCard from "./account/InstalledCard";
import Grid from "@mui/material/Grid";
import { useLocation } from "react-router-dom";

const MyAccount = () => {
  const location = useLocation();
  const { enrollee, step, story, clientCheckData } = location.state || {};
  return (
    <div
      style={{
        display: "flex",
        flexGrow: 1,
        alignItems: "center",
        justifyContent: "center",
        marginTop: "100px",
      }}
    >
      <Grid>
        {clientCheckData?.clientStatus === "Installed" ? (
          <InstalledCard />
        ) : (
          clientCheckData?.clientStatus === "Scheduled" && (
            <AppointmentCard enrollee={enrollee} step={step} story={story} clientCheckData={clientCheckData} />
          )
        )}
      </Grid>
    </div>
  );
};

export default MyAccount;
